import { render, staticRenderFns } from "./UserRight.vue?vue&type=template&id=d1d92182&scoped=true"
import script from "./UserRight.vue?vue&type=script&lang=js"
export * from "./UserRight.vue?vue&type=script&lang=js"
import style0 from "./UserRight.vue?vue&type=style&index=0&id=d1d92182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d92182",
  null
  
)

export default component.exports